import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import { AdminRoute } from '@/auth/AdminRoute';
import { SuperAdminRoute } from '@/auth/SuperAdminRoute';
import { AppLayout } from '@/components/layout/AppLayout';
import { NotFoundPage } from '@/components/common/NotFoundPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { AnalyticsPage } from '@/pages/AnalyticsPage';
import { ExportCenterPage } from '@/pages/ExportCenterPage';
import { AdminUsersPage } from '@/pages/admin/AdminUsersPage';
import { AuditLogPage } from '@/pages/admin/AuditLogPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { LogsPage } from '@/pages/LogsPage';
import { ReviewCatalogPage } from '@/pages/admin/ReviewCatalogPage';

/** Locally authenticated routes; authorization is enforced by the backend. */
export function App() {
  return (
    <Routes>
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="inspections" element={<Navigate to="/logs" replace />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="exports" element={<ExportCenterPage />} />
          <Route path="profile" element={<ProfilePage />} />

          <Route path="admin" element={<AdminRoute />}>
            <Route index element={<Navigate to="review-categories" replace />} />
            <Route element={<SuperAdminRoute />}>
              <Route path="users" element={<AdminUsersPage />} />
            </Route>
            <Route path="reference-data" element={<Navigate to="/admin/review-categories" replace />} />
            <Route path="review-categories" element={<ReviewCatalogPage />} />
            <Route path="audit-log" element={<AuditLogPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
